// https://vuex.vuejs.org/en/actions.html

export default {
  loadConfig({ commit, rootState }) {
    rootState.db
      .doc("setup/config")
      .get()
      .then(function(doc) {
        if (doc.exists) {
          console.log(doc.data());
          commit("setConfig", doc.data());
        } else {
          console.log("Does not exist! Using defaults");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
    //commit("setUser", null);
  }
};
